<template>
  <section>
    <form method="post" @submit.prevent="onUpdate" novalidate>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{
              $t('attributes.modify') +
                $t('attributes.banner') +
                $t('attributes.regular')
            }}
          </p>
        </header>

        <section class="modal-card-body">
          <form-wrapper :validator="$v.form">
            <form-group
              horizontal
              name="big_banner_show_type"
              attribute="attributes.display_mode"
              :label="$t('attributes.display_mode')"
            >
              <b-select
                v-model="form.big_banner_show_type"
                name="big_banner_show_type"
                expanded
              >
                <option
                  v-for="option in modelOptions"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </form-group>
            <form-group horizontal label="正常">
              <p>排序序號從小到大的排序方式</p>
            </form-group>
            <form-group horizontal label="亂數">
              <p>無視原本排序序號，全部打亂重新排序。</p>
            </form-group>
            <form-group horizontal label="亂數+正常">
              <p>
                相同排序序號視為群組，依照群組序號從小到大分別取出重新打亂排序。
              </p>
            </form-group>
          </form-wrapper>
        </section>

        <footer class="modal-card-foot">
          <b-button
            :loading="isLoading"
            class="is-fullwidth"
            @click="$parent.close()"
          >
            {{ $t('attributes.close') }}
          </b-button>
          <b-button
            :loading="isLoading"
            type="is-primary"
            class="is-fullwidth"
            native-type="submit"
          >
            {{ $t('attributes.update') }}
          </b-button>
        </footer>

        <b-loading :active.sync="isLoading" :can-cancel="false"></b-loading>
      </div>
    </form>
  </section>
</template>

<script>
import { HOME_API } from '@/utils/apis'
import { required } from 'vuelidate/lib/validators'
import notifyService from '@/services/notifyService'

export default {
  name: 'ConfigForm',
  data() {
    return {
      loading: false,
      sending: false,
      form: {
        big_banner_show_type: ''
      },

      modelOptions: [
        { name: '正常', value: '正常' },
        { name: '亂數', value: '亂數' },
        { name: '亂數+正常', value: '綜合' }
      ]
    }
  },
  validations: {
    form: {
      big_banner_show_type: { required }
    }
  },
  computed: {
    isLoading() {
      return this.loading || this.sending
    }
  },
  mounted() {
    this.loadConfig()
  },
  methods: {
    async loadConfig() {
      const api = `${HOME_API}/banner_sort`
      try {
        this.loading = true

        const res = await this.axios.get(api)

        this.form.big_banner_show_type = res.data.data.banner_show_type
      } catch (e) {
        notifyService.fetch_error('display_mode', e)
      } finally {
        this.loading = false
      }
    },
    async onUpdate() {
      const api = `${HOME_API}/banner_sort`
      try {
        this.sending = true
        const res = await this.axios.put(api, this.form)

        this.form.big_banner_show_type = res.data.data.banner_show_type

        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>
